module.exports = function map(iterator, arr) {
	//shim for Array.prototype.map
	var results = [];
	results.length = arr.length;
	for (var i = 0; i < arr.length; i++) {
		if (arr[i] !== undefined) {
			results[i] = iterator(arr[i], i, arr);
		}
	}
	return results;
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/util/array/map.js
 ** module id = 15
 ** module chunks = 0
 **/